import { IconButton, Tooltip } from '@mui/material';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import Iconify from '../../../../reusable-components/iconify';

ProductFileAttachmentButton.propTypes = {
  setFiles: PropTypes.func,
};
export default function ProductFileAttachmentButton({ setFiles }) {

  const fileInputRef =  useRef(null);
  
  const addProductFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const inputFiles = Array.from(event.target.files);
    setFiles((prevFiles) => Array.isArray(prevFiles) ? [...prevFiles, ...inputFiles] : inputFiles);
  };

  return (
    <>
      <Tooltip title={'Add File'}>
        <IconButton onClick={addProductFile}>
          <Iconify icon="mdi:attachment" width={24} height={24} color="primary"/>
        </IconButton>
      </Tooltip>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        multiple
      />
    </>
  )
}